import { Flex, Text } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { ModalBase } from '../../../../../components/ModalBase'
import { CargoNivelCriterioResponse, NivelCriterioResponse } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'

interface iModal {
  isOpen: boolean
  onClose: () => void
  criterioId: string
  nomeCriterio: string
  nivel?: NivelCriterioResponse
  minimo: boolean
}

export const ModalCargosNivel: React.FC<iModal> = ({ isOpen, onClose, criterioId, nomeCriterio, nivel, minimo }) => {
  const [Cargos, setCargos] = useState<CargoNivelCriterioResponse[]>([])
  const [IsLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!isOpen || !nivel) return
    let ativo = true
    setCargos([])
    setIsLoading(true)

    appApi.get(`api/Criterios/${criterioId}/Niveis/${nivel.id}/Cargos?minimo=${String(minimo)}`)
      .then(res => { if (ativo) setCargos(res.data) })
      .catch(err => console.log(err))
      .finally(() => { if (ativo) setIsLoading(false) })

    return () => { ativo = false }
  }, [isOpen, criterioId, nivel, minimo])

  return (
    <ModalBase
      Titulo='Cargos atribuídos ao nível'
      Subtitulo={nivel ? `${nomeCriterio}: ${nivel.nome} (Pontuação: ${nivel.pontuacao})` : ''}
      isOpen={isOpen}
      onClose={onClose}
      Width='40rem'
    >
      <Flex flexDir='column' px='1.5rem' py='1rem' gap='.5rem' maxH='60vh' overflowY='auto'>
        <LoadingContainer linhas={6} loading={IsLoading}>
          {Cargos.length === 0 && <Text fontSize='14px'>Nenhum cargo está atribuído a este nível.</Text>}
          {Cargos.map(cargo => (
            <Text key={cargo.cargoId} fontSize='14px'>
              <strong>{cargo.nomeCargo}</strong>: {cargo.niveis.join(', ')}
            </Text>
          ))}
        </LoadingContainer>
      </Flex>
      <Flex justifyContent='end' padding='1rem'>
        <ButtonCmp onClick={onClose} VarColor='c6'>Fechar</ButtonCmp>
      </Flex>
    </ModalBase>
  )
}
